import styled from "@emotion/styled";
import { color } from "metabase/lib/colors";

export const ReadPermissionLabel = styled.span`
  color: ${color("accent4")};
`;

export const WritePermissionLabel = styled.span`
  color: ${color("success")};
`;
